import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const BONUSES = [{
  title: 'Tablero de Mando Semanal Anti-Domingo',
  desc: 'Tu semana entera resuelta en 10 minutos. Sin improvisar.',
  value: '$8.000'
}, {
  title: 'El Detector de Basura IA',
  desc: 'Checklist para revisar en 3 min si lo que generó la IA sirve.',
  value: '$6.000'
}, {
  title: 'Banco de Consignas Perfectas',
  desc: '120 consignas claras y accionables que evitan el "No entendí".',
  value: '$7.000'
}, {
  title: 'Kit Anti-Corrección Infinita',
  desc: 'Devoluciones rápidas e inteligentes que motivan y ahorran horas.',
  value: '$6.000'
}, {
  title: 'Plantillas de Evaluación Express',
  desc: '15 modelos listos. Completá 3 datos y tenés tu evaluación.',
  value: '$8.000'
}, {
  title: 'El Organizador de Material IA',
  desc: 'Sistema de carpetas para ordenar todo una sola vez. Para siempre.',
  value: '$5.000'
}];
export function BonusSection() {
  return <section className="pt-0 pb-12 bg-zinc-950 relative overflow-hidden" data-id="element-21">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl h-[300px] bg-yellow-500/5 blur-[150px] rounded-full pointer-events-none" data-id="element-22" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-8" data-id="element-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 text-red-500 font-bold uppercase tracking-wider text-xs mb-3 animate-pulse" data-id="element-25">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-26"></span>
            Gratis solo por hoy
          </div>

          <h2 className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white max-w-3xl mx-auto leading-tight" data-id="element-27">
            🎁 Si Comprás Hoy, te Llevás Estos{' '}
            <span className="text-yellow-500" data-id="element-28">6 Bonus Extra</span> Gratis
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-29">
          {BONUSES.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.07
        }} className="bg-zinc-900 border border-zinc-800 rounded-lg p-3.5 hover:border-yellow-500/30 transition-all" data-id="element-30">
              <div className="flex items-center justify-between mb-2" data-id="element-31">
                <GiftIcon className="w-4 h-4 text-yellow-500" data-id="element-32" />
                <span className="bg-green-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-33">
                  Gratis
                </span>
              </div>

              <h3 className="text-sm font-black uppercase text-yellow-500 mb-1 leading-tight" data-id="element-34">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-xs leading-snug mb-2" data-id="element-35">
                {bonus.desc}
              </p>

              <div className="pt-2 border-t border-zinc-800 flex items-center justify-between text-xs" data-id="element-36">
                <span className="text-gray-500 line-through" data-id="element-37">
                  {bonus.value}
                </span>
                <span className="text-green-500 font-bold" data-id="element-38">$0</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}